<template>
  <div>
    <label for="region" class="text-capitalize">{{
      lang.get('terms-service.region.singular')
    }}</label>
    <select id="region" name="region" class="form-control">
      <option
        v-for="(region, key) in regions[country]"
        :key="key"
        :value="key"
        >{{ region }}</option
      >
    </select>
  </div>
</template>

<script>
import langMixin from './Translations/mixins/lang-mixin';

export default {
  name: 'RegionSelector',
  mixins: [langMixin],
  props: {
    regions: {
      type: Object,
      required: true
    },
    country: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
